export default __webpack_public_path__ + "static/ratchel-talk-2251b2743f5834c69c2e6607a6f8d73b.png";